<template>
  <div :class="device.isMobile ? 'py-2' : 'px-4 pb-2'">
    <v-overlay v-if="loading.fetchChildRestaurants" :absolute="true">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      
      <v-data-table
        :headers="headers"
        :items-per-page="-1"
        :items="customSearch(childRestorans, headers, filters.search)"
        class="striped-table ordera-box-shadow"
        hide-default-footer
        disable-pagination
        mobile-breakpoint="0"
        :loading="loading.fetchChildRestaurants"
      >
        <template v-slot:item.num="{ item, index }">
          {{ item && item.name && item.name !== $t("total") ? index + 1 : "" }}
        </template>
        <template v-slot:item.count="{ item }">
          <p style="text-align: right; width: 90px">
            {{ translate(item.count) }}
          </p>
        </template>
    </v-data-table>
  </div>
</template>

<script>
import reportService from "@/services/report";
import hasPrinting from "@/mixins/hasPrinting";
import hasReportPrinting from "@/mixins/report/hasReportPrinting";
import hasExcel from "@/mixins/hasExcel";

export default {
  name: "ReportMealsTabRestaurants",
  mixins: [hasPrinting, hasReportPrinting, hasExcel],
  data: () => ({
    childRestorans: [],
    loading: {
      fetchChildRestaurants: false,
    },
  }),
  methods: {
    async fetchChildRestaurants() {
      if (this.loading.fetchChildRestaurants) {
        console.warn("Fetch child restaurants operation already in progress, skipping duplicate request");
        return;
      }

      this.loading.fetchChildRestaurants = true;

      try {
        const response = await reportService.getRestaurantChildRestaurant(this.$store.state.restaurant.id, {
          date: this.filters.dates.from,
          date2: this.filters.dates.to,
        });
        
        this.childRestorans = response.data.map((item) => ({
          ...item,
          name: this.toLatin(item.name),
        }));
      } catch (error) {
        console.error("Error fetching child restaurants:", error);
      } finally {
        this.loading.fetchChildRestaurants = false;
      }
    },
  },
  computed: {
    headers() {
      return [
        { text: this.$t("r_b"), value: "num" },
        { text: this.$t("restaurant"), value: "name" },
        { text: this.$t("meal_num"), value: "count" },
      ];
    },
    filters() {
      return this.$store.state.report.filters;
    },
  },
  watch: {
    "filters.dates": {
      handler: function () {
        this.fetchChildRestaurants();
      },
      immediate: true,
      deep: true,
    },
    isPrinting() {
      if (this.isPrinting) {
        this.printDocument({
          title: [this.$t("report"), this.$t("restaurants")].join(": "),
          tables: [
            {
              headers: this.headers,
              items: this.customSearch(
                this.childRestorans,
                this.headers,
                this.filters.search
              ).map((item, index) => {
                return {
                  ...item,
                  num: index + 1,
                };
              }),
              showCaption: true,
            },
          ],
          subtitle: this.subtitle,
          hideDatetime: true,
        });
      }
    },
    isExcelDownloading() {
      if (this.isExcelDownloading) {
        this.downloadExcel({
          fileName: [this.$t("report"), this.$t("restaurants")].join(" ") + ".xlsx",
          sheets: [
            {
              name: this.$t("restaurants"),
              headers: this.headers,
              items: this.customSearch(
                this.childRestorans,
                this.headers,
                this.filters.search
              ).map((item, index) => {
                return {
                  ...item,
                  num: index + 1,
                };
              }),
              title: [this.$t("report"), this.$t("restaurants")].join(" "),
              subtitle: this.subtitle,
            },
          ],
        });
      }
    },
  },
};
</script>
